// 'use strict'
import "babel-polyfill"

//Add debug components to window. Allows us to play with controls
//in the console.
window.components = {}
window.m = global.m = require('mithril')
// const m = require('mithril')
// window.m = m
var mx = require('mithril-translate/dist/mithril-translate.min')
window.mx = mx


// var satni = require('./components/satni')
import satni from './components/satni'
require('es5-shim')

// document.addEventListener('DOMContentLoaded', function() {

satni.loadLocale()
	.then(function () {
    m.mount(document.getElementById("content"), satni)
  })

// export default satni
// } )
